// https://docs.datadoghq.com/real_user_monitoring/browser/
import { datadogRum } from '@datadog/browser-rum'

window.DD_RUM = datadogRum
